import React from 'react';
import {
    Dialog,
    DialogHeader,
    DialogContent,
    DialogFooter,
    Button,
    DialogBody,
} from '@indeed/ifl-components';
import GettextFactory from '../../../util/GettextFactory';
import { useApplyForMeCopy } from '../hooks/useApplyForMeCopy';

export interface ResumeValidationDialogProps {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback when dialog is closed/dismissed */
    onOpenChange: (open: boolean) => void;
    /** Callback for OK button - redirects to resume page */
    onOk: () => void;
}

/**
 * Resume validation dialog component
 * Displays when user tries to continue without a resume selected
 * Shows error message and redirects to resume page on OK
 */
export const ResumeValidationDialog: React.FC<ResumeValidationDialogProps> = ({
    isOpen,
    onOpenChange,
    onOk,
}) => {
    const gt = GettextFactory();
    const copy = useApplyForMeCopy();

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange} size="sm" portaled>
            <DialogContent>
                <DialogHeader labelClose={gt.gettext('Close')}>
                    {gt.gettext('Something went wrong')}
                </DialogHeader>
                <DialogBody>{copy.resumeValidationDialogBody}</DialogBody>

                <DialogFooter>
                    <Button
                        variant="primary"
                        onClick={() => {
                            onOk();
                            onOpenChange(false);
                        }}
                        full
                    >
                        {gt.gettext('OK')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
